import { getLastLoginPlatform } from '../../../../../../general/js/helpers';

export const isSignInSuccess = (signInFormProps) => {
    const {
        isSignInSuccessful,
        isNewPasswordRequired,
        loading
    } = signInFormProps;

    return !loading &&
        !isNewPasswordRequired &&
        isSignInSuccessful;
};

export const getLastLogInData = () => {
    const date = new Date();

    const lastLoginDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    const lastLoginPlatform = getLastLoginPlatform();
    const lastLoginDevice = 'Website';

    return {
        lastLoginDate,
        lastLoginPlatform,
        lastLoginDevice
    };
};

export const hasAgreeToPrivacyPolicyChecked = (optIns) => {
    if (optIns.agreedToPrivacyPolicy === undefined || optIns.agreedToPrivacyPolicy === false) return false;

    return true;
};
